<template>
  <div class="notifications">
    <ul>
    <li class="notifications__item" v-for="(item, index) in notifications">
        <div>
            <div class="close" @click="clearNotification(item)"><i class="material-icons">close</i></div>
            <h1 class="notifications__item-title">{{ item.title }}</h1>
            <p class="notifications__item-text">{{ item.text }}</p>
        </div>
    </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
    name: 'notifications',
    computed: {
        ...mapGetters(['notifications'])
    },
    methods: {
        ...mapMutations(['clearNotification'])
    },
    remote: {
        ...mapActions(['notify'])
    }
}
</script>
